import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { printableInvoiceService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'printableInvoice',
  initialState: adapter.getInitialState({
    busy: false,
    contractDocument: {},
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setContractDocumentData: (state, { payload }) => ({ ...state, contractDocument: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const getContractDocumentData = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const { accessToken, ...apiParams } = params;
    const resData = await printableInvoiceService.getContractDocumentData(apiParams, accessToken);
    dispatch(slice.actions.setContractDocumentData(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  getContractDocumentData,
};

export { actions };

export default slice.reducer;
